import { useQuery } from '@tanstack/react-query';

import { GcvAdminApi } from 'api';
import { SFTP_SALES_PROVIDER_KEY } from 'tanstack-hooks/keys';

export function useSftpSalesProvider(providerId: string) {
  const gcvAdminApi = new GcvAdminApi();

  const { data: sftpSalesProvider, isLoading: isLoadingSftpSalesProvider } = useQuery({
    enabled: !!providerId.length,
    queryKey: [SFTP_SALES_PROVIDER_KEY, providerId],
    queryFn: () => gcvAdminApi.getSftpSalesProvider(providerId),
    meta: {
      snackbarErrorMessage: 'There was an issue loading the SFTP sales provider. Please try again.'
    }
  });

  return { sftpSalesProvider, isLoadingSftpSalesProvider };
}
